import { Check } from "lucide-react";

import { getPasswordRequirementState } from "@/lib/passwordPolicy";

export default function PasswordRequirements({ password }) {
  return (
    <div className="native-v3-password-rules grid gap-1 text-xs text-muted-foreground" aria-label="Lösenordskrav">
      {getPasswordRequirementState(password).map((requirement) => (
        <span
          key={requirement.id}
          data-valid={requirement.valid ? "true" : "false"}
          className="flex items-center gap-1.5 data-[valid=true]:text-emerald-600 dark:data-[valid=true]:text-emerald-400"
        >
          <Check className="h-3.5 w-3.5" aria-hidden="true" />
          {requirement.label}
        </span>
      ))}
    </div>
  );
}
